module.exports = __webpack_public_path__ + "img/pink100.e5efcb39.png";